import { Injectable } from '@angular/core';

import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { SetStateResponse } from '@shared/square/models';
import { ApiClientService } from '@tablesready/api-client';

@Injectable({
  providedIn: 'root'
})
export class SquareService {
  private readonly baseUrl = '/v.1/square';

  constructor(
    private readonly http: ApiClientService
  ) { }

  getAppId() {
    return this.http.get(`${this.baseUrl}/appId`, { responseType: 'text'}).pipe(
      catchError((error) => {
        throw new Error(`${error.message}`);
      })
    );
  }

  getData() {
    return this.http.get<any>(`${this.baseUrl}/data`).pipe(
      map(({success, data, error}) => {
        if(success) {
          return data;
        } else {
          throw new Error(`${error}`);
        }
      })
    );
  }

  disconnectSquare() {
    return this.http.get<any>(`${this.baseUrl}/disconnect`).pipe(
      map(({success, data, error}) => {
        if(success) {
          return data;
        } else {
          throw new Error(`${error}`);
        }
      })
    );
  }

  updateLocations() {
    return this.http.get<any>(`${this.baseUrl}/locations/update`).pipe(
      map(({success, data, error}) => {
        if(success) {
          return data;
        } else {
          throw new Error(`${error}`);
        }
      })
    );
  }

  listCategories() {
    return this.http.get<any>(`${this.baseUrl}/categories`).pipe(
      map(({success, data, error}) => {
        if(success) {
          return data;
        } else {
          throw new Error(`${error}`);
        }
      })
    );
  }

  subscribeLocations(options) {
    return this.http.post<any>(`${this.baseUrl}/locations/subscribe`, options).pipe(
      map(({success, data, error}) => {
        if(success) {
          return data;
        } else {
          throw new Error(`${error}`);
        }
      })
    );
  }

  setState(): Observable<SetStateResponse> {
    return this.http.put<SetStateResponse>(`${this.baseUrl}/state`, {});
  }
}
